import React from 'react'

export default function Maintainance() {
   return (
      <>
      <div class="main-wrapper">
          <div class="error-box mt-20">
              <div class="error-box-img"><img class="img-fluid" src={"../../theme/assets/img/error-02.png"} alt="" /></div>
              <h3 class="h2 mb-3"> The Website is Under Construction</h3>
              <p class="h4 font-weight-normal">We are working on fixing the problem. We back soon</p>
          </div>
      </div>
      </>
   )
}
